const meetingMinutesNames = Object.freeze({
  contact_arrived: "contact-arrived",
  contact_left: "contact-left",
  participant_arrived: "participant-arrived",
  participant_left: "participant-left",
  mandate_added: "mandate-added",
  mandate_moved: "mandate-moved",
  mandate_left: "mandate-left",
  general_details: "general-details",
  meeting_start: "meeting-start",
  correspondence: "correspondence",
  resolution_vote: "resolution-vote",
  resolution_major_change: "resolution-major-change",
  meeting_end: "meeting-end",
});

const meetingStatuses = Object.freeze({
  created: 0,
  mandatesCreated: 1,
  invitationSent: 2,
  completed: 3,
  canceled: 4,
  started: 5,
  invitationReadyToBeSent: 6,
  invitationInProgress: 7,
  pvReadyToBeSent: 8,
  pvInProgress: 9,
  pvSent: 10,
  archived: 11,
  toBeDeleted: 12,
});

export { meetingMinutesNames, meetingStatuses };
